module.exports = __webpack_public_path__ + "icon-128x128.png";


//////////////////
// WEBPACK FOOTER
// ./node_modules/file-loader?name=[name].[ext]!./app/images/icon-128x128.png
// module id = ./node_modules/file-loader/index.js?name=[name].[ext]!./app/images/icon-128x128.png
// module chunks = 7